import { GroupColorTheme } from '../types';

export interface GroupThemeConfig {
  bg: string;
  border: string;
  headerText: string;
  accent: string;
  shadow: string;
  hoverBg: string;
}

export const GROUP_THEMES: Record<GroupColorTheme, GroupThemeConfig> = {
  slate: {
    bg: 'rgba(40, 40, 45, 0.55)',
    border: 'rgba(255, 255, 255, 0.12)',
    headerText: 'rgba(255, 255, 255, 0.6)',
    accent: '#64748b',
    shadow: '0 4px 16px rgba(0,0,0,0.15)',
    hoverBg: 'rgba(40, 40, 45, 0.7)',
  },
  blue: {
    bg: 'rgba(30, 58, 138, 0.45)',
    border: 'rgba(59, 130, 246, 0.5)',
    headerText: 'rgba(147, 197, 253, 0.8)',
    accent: '#3b82f6',
    shadow: '0 4px 16px rgba(59, 130, 246, 0.15)',
    hoverBg: 'rgba(30, 58, 138, 0.6)',
  },
  emerald: {
    bg: 'rgba(6, 78, 59, 0.45)',
    border: 'rgba(16, 185, 129, 0.5)',
    headerText: 'rgba(110, 231, 183, 0.8)',
    accent: '#10b981',
    shadow: '0 4px 16px rgba(16, 185, 129, 0.15)',
    hoverBg: 'rgba(6, 78, 59, 0.6)',
  },
  amber: {
    bg: 'rgba(120, 53, 15, 0.45)',
    border: 'rgba(245, 158, 11, 0.5)',
    headerText: 'rgba(252, 211, 77, 0.8)',
    accent: '#f59e0b',
    shadow: '0 4px 16px rgba(245, 158, 11, 0.15)',
    hoverBg: 'rgba(120, 53, 15, 0.6)',
  },
  rose: {
    bg: 'rgba(136, 19, 55, 0.45)',
    border: 'rgba(244, 63, 94, 0.5)',
    headerText: 'rgba(253, 164, 175, 0.8)',
    accent: '#f43f5e',
    shadow: '0 4px 16px rgba(244, 63, 94, 0.15)',
    hoverBg: 'rgba(136, 19, 55, 0.6)',
  },
  purple: {
    bg: 'rgba(88, 28, 135, 0.45)',
    border: 'rgba(168, 85, 247, 0.5)',
    headerText: 'rgba(216, 180, 254, 0.8)',
    accent: '#a855f7',
    shadow: '0 4px 16px rgba(168, 85, 247, 0.15)',
    hoverBg: 'rgba(88, 28, 135, 0.6)',
  },
};

export const COLOR_OPTIONS: { color: GroupColorTheme; label: string; bg: string }[] = [
  { color: 'slate',   label: '灰',  bg: '#64748b' },
  { color: 'blue',    label: '蓝',  bg: '#3b82f6' },
  { color: 'emerald', label: '绿',  bg: '#10b981' },
  { color: 'amber',   label: '橙',  bg: '#f59e0b' },
  { color: 'rose',    label: '红',  bg: '#f43f5e' },
  { color: 'purple',  label: '紫',  bg: '#a855f7' },
];

export function getGroupTheme(color: GroupColorTheme): GroupThemeConfig {
  return GROUP_THEMES[color] || GROUP_THEMES.slate;
}
